import React, { useContext } from 'react';
import modalContext from '../../context/modal/modalContext';
import CustomModal from '../../components/CustomModal';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';

const DisclaimerModal: React.FC = () => {
    const { closeModal } = useContext(modalContext);
    const onClose = () => closeModal('disclaimerModal');

    return (
        <CustomModal
            modalName='disclaimerModal'
            className='disclaimer-modal'
            shouldCloseOnOverlayClick={false}
        >
            <CustomModalHeader title='Disclaimer' onClose={onClose} />
            <div className='content'>
                This is a demo version with mock data. The product is no longer live.
            </div>
        </CustomModal>
    );
};

export default DisclaimerModal;
